._dev-mode-toggle-container_rz83j_1 {
  margin-left: 40px; }

._dev-mode-toggle_rz83j_1 {
  position: absolute;
  right: 0;
  margin-top: 2px; }
